import { StyleSheet } from 'react-native';
import React from "react";
import PlaceholderContainer from "./PlaceholderContainer";
import { PlaceholderLine } from 'placeholders/Placeholder'

const PlaceholderText = ({ addTitle = false, containerStyle = {} }) => {
	
	return (
		<PlaceholderContainer
			style={ [
				containerStyle,
				staticStyles.placeholderContainerAlignItemsCenter
			] }>
			
			<PlaceholderLine width={80} />
			<PlaceholderLine width={60} />
			<PlaceholderLine width={100} />
		</PlaceholderContainer>
	)
}

const staticStyles = StyleSheet.create({
	placeholderContainerAlignItemsCenter: {
		alignItems: 'center',
	},
});

export default PlaceholderText
